export default __webpack_public_path__ + "static/media/undraw_empty.8ceb0f81.svg";